import React, { useEffect } from 'react';
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider
} from 'react-router-dom';

import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgramsSummaryPage from './pages/ProgramsSummary';
import TeamPage from './pages/TeamPage';
import TeamUserBio from './pages/TeamUserBio';
import PrivacyPage from './pages/Privacy';
import DonatePage from './pages/DonatePage';
import DonationSuccess from './pages/DonationSuccess';
import DonationCancel from './pages/DonationCancel';
import NotFoundPage from './pages/NotFoundPage';
import KidsProgramPage from './pages/KidsProgramPage';
import CodingCurriculum from './pages/CodingCurriculum';
import Questionnaire from './pages/CodingForKidsQuestionnaire';
import YouthLeadershipAndMentorshipPage from './pages/YouthLeadershipAndMentorship';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminBlog from './pages/AdminBlog';
import PayPalTest from './pages/PayPalTest';

// Full router with all routes including donation pages
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<MainLayout />}>
      <Route index element={<HomePage />} />
      <Route path="/about-us/who-we-are" element={<AboutPage />} />
      <Route path="about-us/team" element={<TeamPage />} />
      <Route path="about-us/team/:slug" element={<TeamUserBio />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/donate" element={<DonatePage />} />
      <Route path="/donation/success" element={<DonationSuccess />} />
      <Route path="/donation/cancel" element={<DonationCancel />} />
      <Route path="/programs/overview" element={<ProgramsSummaryPage />} />
      <Route path='programs/learn-coding' element={<KidsProgramPage/>} />
      <Route path="/programs/learn-coding/curriculum" element={<CodingCurriculum />} />
      <Route path="/programs/learn-coding/questionnaire" element={<Questionnaire />} />
      <Route path="/programs/youth-leadership-and-mentorship" element={<YouthLeadershipAndMentorshipPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/blog" element={<AdminBlog />} />
      <Route path="/paypal-test" element={<PayPalTest />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  )
)

const App = () => {
  useEffect(() => {
    // Disable browser's scroll restoration to prevent conflicts
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <RouterProvider router={router} />
  )
}

export default App